import React from 'react';
import HeroSection from '@components/home/HeroSection';
import AboutPreview from '@components/home/AboutPreview';
import StatsSection from '@components/home/StatsSection';
import ProductsPreview from '@components/home/ProductsPreview';
import MissionVision from '@components/home/MissionVision';
import PartnersSection from '@components/home/PartnersSection';
import CTASection from '@components/home/CTASection';

/**
 * Home Page Component
 * Main landing page with all homepage sections
 */
const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section with Image Slider */}
      <HeroSection />

      {/* About Preview Section */}
      <AboutPreview />

      {/* Statistics Section */}
      <StatsSection />

      {/* Products Preview Section */}
      <ProductsPreview />

      {/* Mission, Vision & Values Section */}
      <MissionVision />

      {/* Partners Section */}
      <PartnersSection />

      {/* Call to Action Section */}
      <CTASection />
    </div>
  );
};

export default Home;